/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FilterViewScope } from './FilterViewScope';
import {
    FilterViewScopeFromJSON,
    FilterViewScopeFromJSONTyped,
    FilterViewScopeToJSON,
} from './FilterViewScope';

/**
 * 
 * @export
 * @interface FilterView
 */
export interface FilterView {
    /**
     * 
     * @type {string}
     * @memberof FilterView
     */
    id: string;
    /**
     * 
     * @type {FilterViewScope}
     * @memberof FilterView
     */
    scope: FilterViewScope;
    /**
     * 
     * @type {string}
     * @memberof FilterView
     */
    view_key: string;
    /**
     * 
     * @type {string}
     * @memberof FilterView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FilterView
     */
    description?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FilterView
     */
    filters: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof FilterView
     */
    is_default: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FilterView
     */
    date_created: Date;
    /**
     * 
     * @type {Date}
     * @memberof FilterView
     */
    date_modified?: Date;
}

/**
 * Check if a given object implements the FilterView interface.
 */
export function instanceOfFilterView(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "scope" in value;
    isInstance = isInstance && "view_key" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "filters" in value;
    isInstance = isInstance && "is_default" in value;
    isInstance = isInstance && "date_created" in value;

    return isInstance;
}

export function FilterViewFromJSON(json: any): FilterView {
    return FilterViewFromJSONTyped(json, false);
}

export function FilterViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'scope': FilterViewScopeFromJSON(json['scope']),
        'view_key': json['view_key'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'filters': json['filters'],
        'is_default': json['is_default'],
        'date_created': (new Date(json['date_created'])),
        'date_modified': !exists(json, 'date_modified') ? undefined : (new Date(json['date_modified'])),
    };
}

export function FilterViewToJSON(value?: FilterView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'scope': FilterViewScopeToJSON(value.scope),
        'view_key': value.view_key,
        'name': value.name,
        'description': value.description,
        'filters': value.filters,
        'is_default': value.is_default,
        'date_created': (value.date_created.toISOString()),
        'date_modified': value.date_modified === undefined ? undefined : (value.date_modified.toISOString()),
    };
}

